import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import Header from "../../layoutComponents/Header";
import { useWebViewContext } from "../../components/WebViewProvider/webViewContext";

const EmailFlowPswResetSuccess = () => {
	const { isWebView } = useWebViewContext();
	const { getValues } = useFormContext();
	const [userEmailAddress, setUserEmailAddress] = useState(null);

	useEffect(() => {
		setUserEmailAddress(getValues("email"));
	}, []);

	return (
		<>
			{isWebView && <Header flex />}

			<Box sx={{ height: { xs: "20px", md: "56px" } }}></Box>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: "1rem" }}>
				<svg width="61" height="60" viewBox="0 0 61 60" fill="none">
					<g>
						<path
							d="M23.5 29.5647L28.4888 36.0162L39.3991 24"
							stroke="#FF5F1F"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M30.5 59C46.5163 59 59.5 46.0163 59.5 30C59.5 13.9837 46.5163 1 30.5 1C14.4837 1 1.5 13.9837 1.5 30C1.5 46.0163 14.4837 59 30.5 59Z"
							stroke="#FF5F1F"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
				</svg>
			</Box>
			<Box sx={{ marginBottom: "2rem", marginTop: "2rem", lineHeight: "24px" }}>
				<Typography variant="body1" align="center">
					Na e-mail <span style={{ fontWeight: "bold" }}>{userEmailAddress}</span> jsme Vám poslali odkaz, přes který si nastavíte
					své heslo pro přihlášení.
				</Typography>
				<Typography marginTop="1rem" variant="body1" align="center">
					Odkaz je platný 30 minut od odeslání.
				</Typography>
				<Typography marginTop="1rem" variant="body1" align="center">
					Pokud e-mail ve schránce nevidíte, zkuste se podívat také do spamu.
				</Typography>
			</Box>
		</>
	);
};

export default EmailFlowPswResetSuccess;
